import { Component, Input, OnInit } from '@angular/core';
import { Blog } from 'src/app/interfaces/blog';
import ar from '@angular/common/locales/ar';
import { registerLocaleData } from '@angular/common';
import { ApplicationLanguages } from 'src/app/enums/lang';
import { ChangeLangService } from 'src/app/services/change-lang/change-lang.service';

@Component({
  selector: 'app-blog',
  templateUrl: './blog.component.html',
  styleUrls: ['./blog.component.scss'],
})
export class BlogComponent implements OnInit {
  @Input() blog!: Blog;
  @Input() isHome: boolean = true;
  currentLang = localStorage.getItem('lang') || ApplicationLanguages.Ar;
  ApplicationLanguages = ApplicationLanguages;

  isExpanded: boolean = false;

  constructor(private changeLangService: ChangeLangService) {}

  ngOnInit(): void {
    registerLocaleData(ar);

    this.changeLangService.currentLanguage.subscribe((lang) => {
      this.currentLang = lang;
    });
  }

  openBlogPage() {}
}
